import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2351d6db"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2351d6db')) {
      api.createRecord('2351d6db', component.options)
    } else {
      api.reload('2351d6db', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2351d6db", function () {
      api.rerender('2351d6db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/rotulopersonalizado/edit.vue"
export default component.exports